import { render } from "./LevelDialog.vue?vue&type=template&id=12adbfca&scoped=true"
import script from "./LevelDialog.vue?vue&type=script&lang=js"
export * from "./LevelDialog.vue?vue&type=script&lang=js"

import "./LevelDialog.vue?vue&type=style&index=0&id=12adbfca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12adbfca"]])

export default __exports__